import React from 'react';

import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import ArrowPointIcon from '../Icons/ArrowPointIcon';
import RoundedIcon from '../Icons/RoundedIcon';
import NavigationButton from './NavigationButton';

const BackButton = (props) => {
    return (
        <NavigationButton rumActionName={awsRumActionNames.BACK} {...props}>
            <RoundedIcon>
                <ArrowPointIcon />
            </RoundedIcon>
        </NavigationButton>
    );
};

export default BackButton;
